import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const BackButton = ({ to = '/', style = {} }) => {
    const navigate = useNavigate();

    return (
        <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => navigate(to)}
            style={{
                position: 'absolute',
                top: 'max(20px, env(safe-area-inset-top))',
                left: '20px',
                background: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.4)',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                zIndex: 1000,
                color: 'white',
                fontSize: '1.2rem',
                backdropFilter: 'blur(5px)',
                ...style
            }}
        >
            ←
        </motion.button>
    );
};

export default BackButton;
